import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import axios from "axios";

// Attach the current org name to every outgoing request, read fresh from
// localStorage each time (not just once) so it stays correct across logins.
axios.interceptors.request.use((config) => {
  const orgName = localStorage.getItem("saved_orgname");
  //console.log("[ORG DEBUG] outgoing request:", config.url, "| saved_orgname =", orgName);
  if (orgName) {
    config.headers["X-Org-Name"] = orgName;
  }
  return config;
});



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <ToastContainer position="bottom-center" autoClose={false} newestOnTop />
  </>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    toast.info(
      () => (
        <div>
          <strong>🔄 New version available</strong>
          <div>
            <button
              onClick={() => {
                registration?.waiting?.postMessage?.({ type: "SKIP_WAITING" });
              }}
              style={{
                marginTop: 8,
                padding: "5px 10px",
                border: "none",
                background: "#007bff",
                color: "#fff",
                cursor: "pointer",
                borderRadius: 4,
              }}
            >
              Refresh Now
            </button>
          </div>
        </div>
      ),
      {
        closeOnClick: false,
        draggable: false,
        position: "bottom-center",
        autoClose: 3000,
        toastId: "sw-update",
      }
    );
  },
});

// ✅ guard: avoid addEventListener crash
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}

reportWebVitals();
